// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".swal2-container {\n  background-image: url(https://cdn2.wuwow.tw/wuwow-junior/vip-background-web.svg);\n  background-size: cover;\n}\n.swal2-container .swal2-modal {\n  border: 1px solid #FFFFFF;\n  box-shadow: 0px 0px 14px rgba(208, 208, 208, 0.25);\n  border-radius: 15px;\n}\n.swal2-container .swal2-success-circular-line-right {\n  background: rgba(255, 255, 255, 0);\n}", ""]);
// Exports
module.exports = exports;
